import { Keys } from '../../utils'
function useTabsKeyboardNavigation() {
  function onKeyDown(e: React.KeyboardEvent<HTMLElement>) {
    const target = e.target as HTMLElement

    const tabs = Array.from(e.currentTarget.querySelectorAll<HTMLElement>('[role="tab"]'))
    const activeTabs = tabs.filter((tab) => !tab.hasAttribute('disabled'))
    const index = activeTabs.indexOf(target)

    if (index < 0) return
    if (e.code === Keys.Enter || e.code === Keys.Space) {
      e.preventDefault()
      const current = activeTabs[index]
      current?.click()
      return
    }
    if (e.code === Keys.Right) {
      e.preventDefault()
      const next = activeTabs[(index + 1) % activeTabs.length]
      next?.focus()
      return
    }
    if (e.code === Keys.Left) {
      e.preventDefault()
      const prev = activeTabs[(index - 1 + activeTabs.length) % activeTabs.length]
      prev?.focus()
      return
    }
    if (e.code === Keys.Home) {
      const firstActive = activeTabs[0]
      firstActive?.focus()
      return
    }
    if (e.code === Keys.End) {
      const lastActive = activeTabs[activeTabs.length - 1]
      lastActive?.focus()
      return
    }
  }

  return { onKeyDown }
}

export default useTabsKeyboardNavigation
